export default "__VITE_ASSET__BmD0iaAC__"